var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#474747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.6666V7.99992H11.9998L9.33317 5.33325L6.6665 7.99992H8.6665V18.6666H9.99984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6665 5.33325H13.3332L12.6665 5.99992V11.3333H13.9998V9.33325H15.9998V11.3333H17.3332V5.99992L16.6665 5.33325ZM15.9998 5.99992H13.9998V8.66658H15.9998V5.99992Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 12.6666H12.6665V13.3333H15.9998L12.6665 17.6666V18.6666H17.3332V17.9999H13.9998L17.3332 13.6666V12.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescending);
export default __webpack_public_path__ + "static/media/SortDescending.71d9733dccc5da2e16a41bdcc6c90307.svg";
export { ForwardRef as ReactComponent };